export default {
    metro: {
        requests: {
            status: 'Статус',
            states: {
                2: 'Черновик',
                3: 'На согласовании',
                4: 'Согласована',
                7: 'В подборе',
                8: 'Отклонена',
                9: 'Аннулирована'
            }
        },
        request: {
            draft: 'Черновик',
            send: 'Отправлена',

            title: 'Заявка на подбор',
            structure: 'Оргструктура',
            jobEvaluation: 'Должность',

            requestRoute: 'Тип заявки',
            region: 'Регион',
            city: 'Город',
            store: 'ТЦ',
            storeCode: 'ТЦ',
            directorateEngl: 'Дирекция',
            unitEngl: 'Подразделение',
            divisionEngl: 'Дивизион',
            department: 'Отдел',

            positionCurrent: 'Изменяемая должность',
            positionNew: 'Новая должность в структуре',
            positionCatalogNumber: '№ должности в каталоге',
            positionCopyNumber: 'Код скопированной должности',

            positionId: 'Код должности',
            positionCode: 'Должность',
            positionTitle: 'Название должности',
            position: 'Название должности',
            positionEngl: 'Название должности (Англ.)',
            initiator: 'Инициатор',
            initiatorName: 'Инициатор заявки',
            chief: 'Имя нанимающего менеджера',
            chiefPosition: 'Должность нанимающего менеджера',
            chiefCode: 'Табельный номер нанимающего менеджера',
            occupationType: 'Вид трудоустройства',
            employmentType: 'Тип занятости',
            chartOfWork: 'График работы',
            accessToPC: 'Есть доступ к компьютеру',
            addVacation: 'Положен дополнительный отпуск',
            northVacation: 'Положен северный отпуск',
            northVacationPlaceholder: 'Дней',
            displacedEmployee: 'Замещаемый сотрудник',
            positionIsVacant: 'Должность вакантна',
            positionPlace: 'Причина возникновения',
            positionDisplaced: 'Замена',
            positionVacanted: 'Новая',
            positionVacant: 'вакантна',
            positionPlaced: 'замена',
            contractPeriod: 'Срок договора',
            mobilePhone: 'Мобильный телефон',
            HQHRGeneralist: 'HR Generalist',
            HQHRBP: 'HR BP',
            HRM: 'Store HRM',
            recruiter: 'Рекрутер',
            HRBPOperations: 'HR BP Operations',
            responsibilities: 'Обязанности',
            requirements: 'Требования',
            competenticies: 'Компетенции',
            values: 'Ценности',
            documents: 'Документы',
            documentAttached: 'Прикрепленные документы',
            documentAttach: 'Прикрепить документ',
            positionCostCenters: 'МВЗ отдела',
            HQ: 'HQ\\Store 1000',
            positionGrade: 'Грейд должности',
            positionLevel: 'Уровень должности',
            salaryLevel: 'Уровень зарплаты (min)',
            salaryLevelMid: 'Уровень зарплаты (mid)',
            bonusScheme: 'Бонусная схема',
            bonusSchemePercent: '% бонусной схемы',
            familyDMS: 'ДМС для членов семьи',
            companyCar: 'Служебный автомобиль',
            travellingWork: 'Разъездной характер работы',
            liabilityContract: 'Наличие договора мат. ответственности',
            positionBudgeted: 'Позиция забюджетирована',
            approval: 'Согласование',
            positionIsInCatalog: 'Должность есть в каталоге',
            positionIsInOrgstr: 'Должность внесена в орг. стр. отдела',
            positionIsInSAP: 'Должность в орг. стр. SAP',
            functionCode: 'Функциональный код отдела\\группы в оргструктуре',
            cellId: 'Код ячейки ШР',
            staffPosition: 'Штатная должность',
            cellIdDescription: 'Информация о текущей штатной позиции',
            searchCellId: 'Загрузить описание должности',
            competences: 'Компетенции',
            comment: 'Комментарий',
            comments: 'Комментарии',
            noComments: 'Нет комментариев',
            departmentsEmpty: 'Отделы не найдены',

            draftSave: 'Заявка успешно сохранена в черновики',
            documentSave: 'Документ прикреплен',
            documentError: 'Не удалось прикрепить документ',
            changesSave: 'Изменения успешно сохранены в заявку',
            sended: 'Заявка успешно отправлена',
            createRoute: 'Создать маршрут по умолчанию',
            approved: 'Заявка успешно согласована',

            routes: {
                mgl: 'MGL',
                hq: 'ЦО',
                store: 'ТЦ',
            },

            approvals: {
                aco: 'АЦО',
                cnb: 'C&B',
                cnbrate: 'C&B Оценка',
                back: 'BackOffice',
            },

            requestType: 'Найти сотрудника',
            types: {
                current: 'Существующая должность',
                new: 'Создать новую должность',
                copy: 'Копировать должность',
            },

            changePosition: 'Внести изменения в должность',

            copyOther: 'Отменить копирование должности',
            copyPositionPlaceholder: 'Выберите должность для копирования',
            copyPosition: 'Должность для копирования',

            positionCodeApproval: 'Введите код должности из каталога SAP',
            positionError: 'Не удалось загрузить описание должности',
            noUnit: 'Нет',
            changePositionDescription: 'Пожалуйста, внесите ваше предложение или оставьте поля пустыми. Поля ниже требуют оценки C&B.',
        },
        requestRoute: {
            title: 'Маршрут согласования заявки',
        },
        send: 'Отправить заявку',
        sendDocument: 'Прикрепить документ',
        save: 'Сохранить заявку',
        saveDraft: 'Сохранить черновик',
        positionFields: 'Требования к должности',
        position: 'Должность',
        approvalRoute: 'Маршрут согласования',
        editApprovalRoute: 'Редактировать маршрут согласования',
        approvalHistory: 'История согласования',
    }
};
